var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon",class:[
    { spin: _vm.spin },
    { disabled: _vm.disabled },
    _vm.sizeClass,
    { 'color-reset': _vm.colorReset },
  ],domProps:{"innerHTML":_vm._s(_vm.getSvg())},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }